import { API_PATH } from '@api/path/path';
import { createHandler, sleep } from '../utils';
import { mockDB } from './../db/index';

export const getLinkedUserList = () =>
  createHandler(API_PATH.User.findLinkedUsers, async (req, res, ctx) => {
    const limit = Number(req.url.searchParams.get('limit')) || 8;
    const requestPageNumber =
      Number(req.url.searchParams.get('requestPageNumber')) || 1;

    const sortField = req.url.searchParams.get('sortField');
    mockDB.user.linkedUsers.set({ sortField, limit });
    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json(mockDB.user.linkedUsers.get({ requestPageNumber })),
    );
  });

export const getLinkedUserById = () =>
  createHandler(API_PATH.User.findLinkedUser, async (req, res, ctx) => {
    const { linkedUserId } = req.params;
    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json(mockDB.user.linkedUsers.getById({ userId: linkedUserId })),
    );
  });

export default [getLinkedUserList(), getLinkedUserById()];
